import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

interface TabItem {
  value: string;
  label: string;
}

interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (next: string) => void;
  className?: string;
}

export function Tabs({ items, value, onChange, className }: TabsProps) {
  return (
    <div className={cn('flex items-center gap-1 border-b border-border', className)}>
      {items.map((it) => {
        const active = it.value === value;
        return (
          <button
            key={it.value}
            type="button"
            onClick={() => onChange(it.value)}
            className={cn(
              'relative px-3 py-2 text-sm transition-colors',
              active
                ? 'text-foreground font-medium'
                : 'text-foreground-muted hover:text-foreground',
            )}
          >
            {it.label}
            {active ? (
              <span className="absolute -bottom-px left-0 right-0 h-0.5 bg-accent" />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

interface TabsPanelProps {
  active: boolean;
  children: ReactNode;
  className?: string;
}

export function TabsPanel({ active, children, className }: TabsPanelProps) {
  if (!active) return null;
  return <div className={className}>{children}</div>;
}
